import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createTextVNode("﻿")),
    _cache[1] || (_cache[1] = _createElementVNode("svg", {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("path", {
        d: "M23 4.5V19.5H2V4.5M23 4.5H2M23 4.5L12.5 12L2 4.5",
        stroke: "black",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1))
  ], 64))
}
export default { render: render }